import Vue from 'vue'
import Router from 'vue-router'

import login from '@/pages/login'
import index from '@/pages/index'
import blank from '@/pages/blank'
import blank2 from '@/pages/blank2'

//welcome
import welcome_index from '@/pages/welcome/index'

//blank
import blank_viewer from '@/pages/blank/viewer'

// 统计报表
import report_sum from '@/pages/report/sum/list'
import report_orgsum from '@/pages/report/orgsum/list'
import report_goodssum from '@/pages/report/goodssum/list'
import report_orggoodssum from '@/pages/report/orggoodssum/list'
import report_day from '@/pages/report/day/list'
import report_cr from '@/pages/report/cr/list'
import report_api from '@/pages/report/api/list'
import report_vendorsum from '@/pages/report/vendorsum/list'
import report_vendorsumgoods from '@/pages/report/vendorsumgoods/list'
import report_vendorday from '@/pages/report/vendorday/list'
import report_orgcr from '@/pages/report/orgcr/list'
import report_orgcrsum from '@/pages/report/orgcrsum/list'

// 充值
import charge_mobile from '@/pages/charge/mobile/list'
import charge_mobilebat from '@/pages/charge/mobilebat/list'
import charge_mobilebat_save from '@/pages/charge/mobilebat/save'

// 订单
import order_c from '@/pages/order/c/list'
import order_cbat from '@/pages/order/cbat/list'
import gorder_c from '@/pages/gorder/c/list'

//base
import base_goodscat from '@/pages/base/goodscat/list'
import base_goodscat_save from '@/pages/base/goodscat/save'
import base_goodscat_save2 from '@/pages/base/goodscat/save2'
import base_orgvendor from '@/pages/base/orgvendor/list'
import base_orgvendor_save from '@/pages/base/orgvendor/save'
import base_orggoods from '@/pages/base/orggoods/list'
import base_orggoods_save from '@/pages/base/orggoods/save'

//商品档案
import product_code from '@/pages/product/code/list'
import product_code_save from '@/pages/product/code/save'

//供应商档案
import vendor_code from '@/pages/vendor/code/list'
import vendor_code_save from '@/pages/vendor/code/save'
import vendor_code_crsn from '@/pages/vendor/code/crsn'

//开发设置
import dp_setup from '@/pages/dp/setup/list'
import dp_api from '@/pages/dp/api/list'

// rw
import rw_orgapp from '@/pages/rw/orgapp/list'
import rw_orgapp_save from '@/pages/rw/orgapp/save'

//org
import org_info from '@/pages/org/info/info'
import org_info_save from '@/pages/org/info/info_save'
import org_dep from '@/pages/org/dep/dep'
import org_dep_save from '@/pages/org/dep/dep_save'
import org_dep_user from '@/pages/org/dep/dep_user'
import org_role from '@/pages/org/role/role'
import org_role_save from '@/pages/org/role/role_save'
import org_role_user from '@/pages/org/role/role_user'
import org_role_func from '@/pages/org/role/role_func'
import org_user from '@/pages/org/user/user'
import org_user_add from '@/pages/org/user/user_add'
import org_user_upd from '@/pages/org/user/user_upd'
import org_user_reset_pwd from '@/pages/org/user/user_reset_pwd'
import org_app from '@/pages/org/app/list'
import org_app_save from '@/pages/org/app/save'
import org_down from '@/pages/org/down/list'
import org_down_save from '@/pages/org/down/save'
import org_down_admin from '@/pages/org/down/admin'
import org_down_org_admin from '@/pages/org/down/org_admin'
import org_shop from '@/pages/org/shop/list'
import org_shop_save from '@/pages/org/shop/save'
import org_shop_admin from '@/pages/org/shop/admin'
import org_shop_org_admin from '@/pages/org/shop/org_admin'
import org_shop_setup from '@/pages/org/shop/setup'
import org_shop_crsn from '@/pages/org/shop/crsn'

//system
import system_func from '@/pages/system/func'
import system_func_save from '@/pages/system/func_save'
import system_mod from '@/pages/system/mod'
import system_mod_save from '@/pages/system/mod_save'
import system_mod_role from '@/pages/system/mod_role'
import system_mod_role_func from '@/pages/system/mod_role_func'
import system_mod_dep from '@/pages/system/mod_dep'
import system_cache from '@/pages/system/cache'
import system_ops from '@/pages/system/ops'
import system_errhigh from '@/pages/system/errhigh'

Vue.use(Router);
export default new Router({
    routes: [
        //统计报表
        {
            path: '/report',
            name: 'report',
            component: index,
            children: [
                {
                    path: 'sum',
                    name: 'sum',
                    component: report_sum
                },
                {
                    path: 'orgsum',
                    name: 'orgsum',
                    component: report_orgsum
                },
                {
                    path: 'goodssum',
                    name: 'goodssum',
                    component: report_goodssum
                },
                {
                    path: 'orggoodssum',
                    name: 'orggoodssum',
                    component: report_orggoodssum
                },
                {
                    path: 'day',
                    name: 'day',
                    component: report_day
                },
                {
                    path: 'cr',
                    name: 'cr',
                    component: report_cr
                },
                {
                    path: 'api',
                    name: 'api',
                    component: report_api
                },
                {
                    path: 'vendorsum',
                    name: 'vendorsum',
                    component: report_vendorsum
                },
                {
                    path: 'vendorsumgoods',
                    name: 'vendorsumgoods',
                    component: report_vendorsumgoods
                },
                {
                    path: 'vendorday',
                    name: 'vendorday',
                    component: report_vendorday
                },
                {
                    path: 'orgcrsum',
                    name: 'orgcrsum',
                    component: report_orgcrsum
                },
                {
                    path: 'orgcr',
                    name: 'orgcr',
                    component: report_orgcr
                }
            ]
        },
        //充值
        {
            path: '/charge',
            name: 'charge',
            component: index,
            children: [
                {
                    path: 'mobile',
                    name: 'mobile',
                    component: charge_mobile
                },
                {
                    path: 'mobilebat',
                    name: 'mobilebat',
                    component: charge_mobilebat,
                    children: [
                        {
                            path: 'save',
                            name: 'save',
                            component: charge_mobilebat_save
                        }
                    ]
                }
            ]
        },
        //客户订单
        {
            path: '/gorder',
            name: 'gorder',
            component: index,
            children: [
                {
                    path: 'c',
                    name: 'c',
                    component: gorder_c
                }
            ]
        },
        //订单
        {
            path: '/order',
            name: 'order',
            component: index,
            children: [
                {
                    path: 'c',
                    name: 'c',
                    component: order_c
                },
                {
                    path: 'cbat',
                    name: 'cbat',
                    component: order_cbat
                }
            ]
        },
        //商品管理
        {
            path: '/product',
            name: 'product',
            component: index,
            children: [
                {
                    path: 'code',
                    name: 'code',
                    component: product_code,
                    children: [
                        {
                            path: 'save',
                            name: 'save',
                            component: product_code_save
                        }
                    ]
                }
            ]
        },
        //供应商档案
        {
            path: '/vendor',
            name: 'vendor',
            component: index,
            children: [
                {
                    path: 'code',
                    name: 'code',
                    component: vendor_code,
                    children: [
                        {
                            path: 'save',
                            name: 'save',
                            component: vendor_code_save
                        },
                        {
                            path: 'crsn',
                            name: 'crsn',
                            component: vendor_code_crsn
                        }
                    ]
                }
            ]
        },
        //开发设置
        {
            path: '/dp',
            name: 'dp',
            component: index,
            children: [
                {
                    path: 'setup',
                    name: 'setup',
                    component: dp_setup
                },
                {
                    path: 'api',
                    name: 'api',
                    component: dp_api
                }
            ]
        },
        //base
        {
            path: '/base',
            name: 'base',
            component: index,
            children: [
                {
                    path: 'goodscat',
                    name: 'goodscat',
                    component: base_goodscat,
                    children: [
                        {
                            path: 'save',
                            name: 'save',
                            component: base_goodscat_save
                        },
                        {
                            path: 'save2',
                            name: 'save2',
                            component: base_goodscat_save2
                        }
                    ]
                },
                {
                    path: 'orgvendor',
                    name: 'orgvendor',
                    component: base_orgvendor,
                    children: [
                        {
                            path: 'save',
                            name: 'save',
                            component: base_orgvendor_save
                        }
                    ]
                },
                {
                    path: 'orggoods',
                    name: 'orggoods',
                    component: base_orggoods,
                    children: [
                        {
                            path: 'save',
                            name: 'save',
                            component: base_orggoods_save
                        }
                    ]
                }
            ]
        },
        //rw
        {
            path: '/rw',
            name: 'rw',
            component: index,
            children: [
                {
                    path: 'orgapp',
                    name: 'orgapp',
                    component: rw_orgapp,
                    children: [
                        {
                            path: 'save',
                            name: 'save',
                            component: rw_orgapp_save
                        }
                    ]
                }
            ]
        },
        // org
        {
            path: '/org',
            name: 'org',
            component: index,
            children: [
                {
                    path: 'info',
                    name: 'info',
                    component: org_info,
                    children:[
                        {
                            path: 'save',
                            name: 'save',
                            component: org_info_save,
                        }
                    ]
                },
                {
                    path: 'dep',
                    name: 'dep',
                    component: org_dep,
                    children:[
                        {
                            path: 'save',
                            name: 'save',
                            component: org_dep_save,
                        },
                        {
                            path: 'user',
                            name: 'user',
                            component: org_dep_user,
                        }
                    ]
                },
                {
                    path: 'role',
                    name: 'role',
                    component: org_role,
                    children:[
                        {
                            path: 'save',
                            name: 'save',
                            component: org_role_save,
                        },
                        {
                            path: 'user',
                            name: 'user',
                            component: org_role_user,
                        },
                        {
                            path: 'func',
                            name: 'func',
                            component: org_role_func,
                        }
                    ]
                },
                {
                    path: 'user',
                    name: 'user',
                    component: org_user,
                    children:[
                        {
                            path: 'add',
                            name: 'org_user_add',
                            component: org_user_add,
                        },
                        {
                            path: 'upd',
                            name: 'upd',
                            component: org_user_upd,
                        },

                        {
                            path: 'resetPwd',
                            name: 'resetPwd',
                            component: org_user_reset_pwd,
                        }
                    ]
                },
                {
                    path: 'app',
                    name: 'app',
                    component: org_app,
                    children:[
                        {
                            path: 'save',
                            name: 'save',
                            component: org_app_save,
                        },
                    ]
                },
                {
                    path: 'down',
                    name: 'down',
                    component: org_down,
                    children:[
                        {
                            path: 'save',
                            name: 'save',
                            component: org_down_save,
                        },
                        {
                            path: 'admin',
                            name: 'admin',
                            component: org_down_admin,
                        },
                        {
                            path: 'org_admin',
                            name: 'org_admin',
                            component: org_down_org_admin,
                        }
                    ]
                },
                {
                    path: 'shop',
                    name: 'shop',
                    component: org_shop,
                    children:[
                        {
                            path: 'save',
                            name: 'save',
                            component: org_shop_save,
                        },
                        {
                            path: 'admin',
                            name: 'admin',
                            component: org_shop_admin,
                        },
                        {
                            path: 'org_admin',
                            name: 'org_admin',
                            component: org_shop_org_admin,
                        },
                        {
                            path: 'setup',
                            name: 'setup',
                            component: org_shop_setup,
                        },
                        {
                            path: 'crsn',
                            name: 'crsn',
                            component: org_shop_crsn,
                        }
                    ]
                },
            ]
        },
        // system
        {
            path: '/system',
            name: 'system',
            component: index,
            children: [
                {
                    path: 'func',
                    name: 'func',
                    component: system_func,
                    children:[
                        {
                            path: 'save',
                            name: 'save',
                            component: system_func_save,
                        }
                    ]
                },
                {
                    path: 'mod',
                    name: 'mod',
                    component: system_mod,
                    children:[
                        {
                            path: 'save',
                            name: 'save',
                            component: system_mod_save,
                        },
                        {
                            path: 'selectRole',
                            name: 'selectRole',
                            component: system_mod_role,
                        },
                        {
                            path: 'roleFunc',
                            name: 'roleFunc',
                            component: system_mod_role_func,
                        },
                        {
                            path: 'selectDep',
                            name: 'selectDep',
                            component: system_mod_dep,
                        },
                    ]
                },
                {
                    path: 'ops',
                    name: 'ops',
                    component: system_ops
                },
                {
                    path: 'errhigh',
                    name: 'errhigh',
                    component: system_errhigh
                },
                {
                    path: 'redis',
                    name: 'redis',
                    component: system_cache,
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/index',
            name: 'index',
            component: index,
            children:[
                {
                    path: 'welcome',
                    name: 'welcome',
                    component: welcome_index,
                }
            ]
        },
        {
            path: '/blank',
            name: 'blank',
            component: blank,
            children:[
                {
                    path: 'viewer',
                    name: 'viewer',
                    component: blank_viewer
                },
            ]
        },
        {
            path: '/blank2',
            name: 'blank2',
            component: blank2
        },
        {
            path: '*',
            redirect: '/index/welcome'
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js